import React from "react";
import "./confirmationModal.css";
import RoundedLinkButton from "../Buttons/RoundedLinkButton/RoundedLinkButton";
import CloseButton from "../Buttons/CloseButton/closeButton";

function ConfirmationModal({
  heading,
  text,
  linkTo = "/",
  linkToAd = "", // /lediga-lokaler/:id
  setShowModal,
  error = false,
  note = "",
}) {
  return error ? (
    <>
      <div className="confirmation-modal" error={error}>
        <h2>{heading}</h2>
        <p>{text}</p>
        <div className="confirmation-modal-btn-row">
          <button
            onClick={() => setShowModal(false)}
            className="confirmation-modal-btn"
          >
            Okej
          </button>
        </div>
      </div>
      <div
        className="confirmation-modal-backdrop"
        onClick={() => setShowModal(false)}
      />
    </>
  ) : (
    <>
      <div className="confirmation-modal">
        <h2>{heading}</h2>
        <p>{text}</p>
        {note && <span>*{note}</span>}
        <div className="confirmation-modal-btn-row">
          {/* Only show "Se annons" link if linkToAd property if passed */}

          {linkToAd && (
            <RoundedLinkButton
              label="Se annons"
              href={linkToAd}
              size="md"
              color="green"
            />
          )}

          <RoundedLinkButton
            label={linkToAd ? "Klar" : "Okej"}
            href={linkTo}
            dataTestID="okay-btn"
            size="md"
            color="green"
          />
        </div>

        <div className="confirmation-modal-close-btn">
          <CloseButton onClick={() => setShowModal(false)} />
        </div>
      </div>
      <div
        className="confirmation-modal-backdrop"
        onClick={() => setShowModal(false)}
      />
    </>
  );
}

export default ConfirmationModal;
